module.exports = __webpack_public_path__ + "img/cb2.38fcc26a.jpg";